module.exports = __webpack_public_path__ + "static/media/rc2.8b710654.png";